/**
 * @class fsubmit
 * @description отправляет форму с помощью fetch
 * @param {object} options - параметры
 * @param {HTMLFormElement} options.form - форма, которую отправляем
 * @param {string} options.subject - тема письма
 * @param {function} options.onSuccess - функция-обработчик, вызываемая при успешной отправке
 * @param {function} options.onError - функция-обработчик, вызываемая при ошибке отправки
 * @param {string} options.url - URL, на который отправляется форма
 *
 * v.0.1.241214 - текущая версия
 * v.0.1.250206 - обновил код
 * v.0.1.250421 - добавил автоматический send_from
 * v.0.2.250428 - добавил beforeSend и this.result + доработки логики
 * v.0.2.250501 - отправка файлов + мелкие доработки
 *
 */

class fsubmit {
	constructor(options) {
		const evt = typeof window.event !== 'undefined' ? window.event : null
		if (evt) evt.preventDefault()

		this.form 				= options.form || (evt ? evt.target : null)
		this.url 					= options.url || this.form.getAttribute('action') || location.href
		this.method 			= (this.form.getAttribute('method') || 'POST').toUpperCase()
		this.headers 			= options.headers || {'Accept': 'application/json'}

		this.fields 			= options.fields || {}
		this.sendingClass = options.sendingClass || '_sending'
		this.submitForm 	= options.submitForm || true
		this.debug 				= options.debug || false
		this.subject 			= options.subject || ''
		this.getUserInfo 	= options.getUserInfo || true
		this.result 			= options.result || null

		this.onBeforeSend = options.onBeforeSend || (() => Promise.resolve())
		this.onSuccess 		= options.onSuccess || (() => { })
		this.onError 			= options.onError || (() => { })
		this.onFinal 			= options.onFinal || (() => { })

		if (evt && evt.type === 'submit') this.handleSubmit()
		else this.bind()
	}


	bind() {
		if (!this.form) return
		this.form.addEventListener('submit', e => {
			e.preventDefault()
			this.handleSubmit()
		})
	}


	// сбор полей с формы
	getFields() {
		const rawFD = new FormData(this.form)

		if (this.subject) rawFD.set('subject', this.subject)

		rawFD.set('send_from', rawFD.get('send_from') || location.href)

		if (this.getUserInfo && typeof getUserInfo === 'function' && typeof getUserInfo.getAll === 'function')
			rawFD.set('user_info', JSON.stringify(getUserInfo.getAll()))

		let hasFile = false
		for (let [k, v] of rawFD.entries()) {
			if (v instanceof File && v.size) {
				hasFile = true; break
			}
		}

		let fields
		if (hasFile) fields = rawFD
		else {
			const obj = {}
			rawFD.forEach((v, k) => {
				if (v instanceof File) if (!v.size) return
				const s = v.toString().trim()
				if (s) obj[k] = s
			})
			fields = JSON.stringify(obj)
		}
		return fields
	}


	showDebug(data = false, title = 'fsubmit debug') {
		if(data === false) data = this
		if(this.debug == true) console.log(title + ':\r\n', data)
	}


	async handleSubmit() {
		// 1) вызываем onBeforeSend и ждём, пока он создаст и заполнит ваше поле
		try {
			await this.onBeforeSend(this.form)
		} catch (err) {
			console.error('✖ Ошибка в onBeforeSend:', err)
			this.onError(err)
			this.form.classList.remove(this.sendingClass)
			this.onFinal()
			return
		}


		// 2) собираем поля если их не было ранее
		// if (Object.keys(this.fields).length == 0 && this.fields.constructor === Object)
		this.fields = this.getFields()

		const opts = {
			method: this.method,
			headers: this.headers,
			body: this.fields
		}
		if(this.isJSON(this.fields)) opts.headers['Content-Type'] = 'application/json'
			else delete opts.headers['Content-Type']

		this.showDebug()

		// 3) отправляем
		if (this.submitForm == true) {
			try {
				this.result = null
				this.form.classList.add(this.sendingClass)

				const res = await fetch(this.url, opts)
				let json
				if(this.headers.Accept == 'application/json') {
					json = await res.json()
				} else {
					const text = await res.text()
					try { json = JSON.parse(text) }
					catch { throw new Error('Ответ не JSON') }
				}

				if (json.success) {
					this.result = true
					this.form.reset()
					this.onSuccess(json)
				} else {
					this.result = false
					throw new Error(json.message)
				}

			} catch (err) {
				this.result = false
				console.error('ERR fsubmit:', err)
				this.onError(err)

			} finally {
				this.showDebug()
				this.form.classList.remove(this.sendingClass)
				this.fields = {}
				this.onFinal()
			}
		}
	}


	isJSON(variable) {
		if (typeof variable !== 'string') return false
		try {
			JSON.parse(variable); return true
		} catch (e) {
			return false
		}
	}
}
